import React from 'react';
import { Input } from 'antd';
import ReferenceManagement from '../../components/admin/ReferenceManagement/ReferenceManagement';
import {
  fetchTypologies,
  createTypologie,
  updateTypologie,
  deleteTypologie,
} from '../../store/slices/referenceSlice';

const { TextArea } = Input;

const TypologieManagement: React.FC = () => {
  const columns = [
    {
      title: 'Libellé',
      dataIndex: 'libelle',
      key: 'libelle',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
  ];

  const formFields = [
    {
      name: 'libelle',
      label: 'Libellé',
      rules: [{ required: true, message: 'Le libellé est obligatoire' }],
      component: <Input placeholder="Libellé de la typologie" />,
    },
    {
      name: 'description',
      label: 'Description',
      rules: [],
      component: <TextArea rows={4} placeholder="Description de la typologie" />,
    },
  ];

  return (
    <ReferenceManagement
      type="typologies"
      title="Gestion des typologies"
      fetchAction={fetchTypologies}
      createAction={createTypologie}
      updateAction={updateTypologie}
      deleteAction={deleteTypologie}
      columns={columns}
      formFields={formFields}
    />
  );
};

export default TypologieManagement;